import { FetchResponse } from '../types/ApiTypes';
import { UpdateDevicePayload } from '../types/CommonTypes';
import { StreamSessionsDetailsResponse } from '../types/Player';
import { executeWithUserToken, tokenRequestHeader } from '../providers/useAuth/AuthService';
import { authSessionPath, authSessionDevicePath, authSessionIdPath } from './apiPaths';
import { apiRequest } from './Api';

export default class KeycloakApi {
    static getDeviceSessions = async (drmRegistered?: boolean): Promise<FetchResponse<StreamSessionsDetailsResponse[]>> =>
        executeWithUserToken<StreamSessionsDetailsResponse[]>(() =>
            apiRequest<StreamSessionsDetailsResponse[]>({
                url: `${authSessionPath()}${drmRegistered ? '?drm-registered=true' : ''}`,
                dataParser: null,
                options: {
                    method: 'GET',
                    headers: tokenRequestHeader(false),
                },
            })
        );

    static updateSessionDevice = async (deviceUuid: string, payload: UpdateDevicePayload) =>
        executeWithUserToken<any>(() =>
            apiRequest<any>({
                url: authSessionDevicePath(deviceUuid),
                dataParser: null,
                options: {
                    method: 'PUT',
                    headers: tokenRequestHeader(false),
                    data: payload,
                },
            })
        );

    static deleteSessionDevice = async (deviceUuid: string, drmRegistered?: boolean) =>
        executeWithUserToken<any>(() =>
            apiRequest<any>({
                url: `${authSessionDevicePath(deviceUuid)}${drmRegistered ? '?drm-registered=true' : ''}`,
                dataParser: null,
                options: {
                    method: 'DELETE',
                    headers: tokenRequestHeader(false),
                },
            })
        );

    static deleteSessionById = async (sessionId: string, drmRegistered?: boolean) =>
        executeWithUserToken<any>(() =>
            apiRequest<any>({
                url: `${authSessionIdPath(sessionId)}${drmRegistered ? '?drm-registered=true' : ''}`,
                dataParser: null,
                options: {
                    method: 'DELETE',
                    headers: tokenRequestHeader(false),
                },
            })
        );
}
